import { Component, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'back-button',
	templateUrl: './back-button.component.html',
	styleUrls: ['./back-button.component.scss'],
	standalone: false,
})
export class BackButtonComponent {
	public readonly route = input<string | any[] | null | undefined>('..');

	constructor(private translate: TranslateService) {}
}
